import {map} from 'lodash';

export function calculateAccIdKey(accIds) {
  return map(accIds, (accId) => accId.id).join(',');
}
